import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  noDestination: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    boxShadow: "0 1px 1px rgba(0, 0, 0, 0.1) !important",
  },
  dropContainer: {
    borderRadius: "8px",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: `0.4px dashed ${theme.palette.grey[300]}`,
    cursor: "pointer",
  },
  textField: {
    "& .MuiInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "yellow",
      },
    },
  },
}));
